// extracted by mini-css-extract-plugin
export var card = "_q9-0";
export var content = "_q9-2";
export var details = "_q9-3";
export var icon = "_q9-1";
export var iconBlue = "_q9-5";
export var iconBrand = "_q9-4";
export var iconGrayBlue = "_q9-6";
export var iconGreen = "_q9-7";
export var iconIndigo = "_q9-8";
export var iconOrange = "_q9-9";
export var iconPurple = "_q9-a";
export var iconRed = "_q9-b";
export var iconWarning = "_q9-c";